import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronUpSm = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 13.5L12 9.5L16 13.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronUpSm.js.map